import React from 'react';
import './Divider.css';
/**
 * Divider is a stupid simple divider component.
 */

var Divider = function Divider() {
  return /*#__PURE__*/React.createElement("hr", null);
};

Divider.defaultProps = {};
export default Divider;